import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { RedirectParams } from '../../../../../../shared/types/redirectParams';
import { ProcedureParamsDataProps } from './props';
import { useEffect, useState } from 'react';
import { ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetLastCodeParam } from '../../../../../../services/param.service';

export const useProcedureParamsData = ({
    data,
    onChangeData,
    onChangeFormik,
}: ProcedureParamsDataProps) => {
    const [newCode, setNewCode] = useState<string>('');

    const onSubmit = (data: RedirectParams) => {
        if (onChangeData) onChangeData(data || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('class', data?.class || ParamEnum.PQR_PROCEDURE);
        formik?.setFieldValue('code', data?.code || newCode);
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('extra', data?.extra || '');
        formik?.setFieldValue('active', data?.active || true);
    }, [data, newCode]);

    useEffect(() => {
        asyncGetLastCodeParam(ParamEnum.PQR_PROCEDURE).then((res: any) => {
            setNewCode(res?.items);
        });
    }, [newCode]);

    return {
        formik,
    };
};
